module.exports = __webpack_public_path__ + "static/img/dy.5f075a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dy.jpg
// module id = FyMR
// module chunks = 26